import { Component, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Pipe, PipeTransform } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { DomSanitizer } from "@angular/platform-browser";
import { NgxSpinnerService } from "ngx-spinner";
import { AngularEditorConfig } from "@kolkov/angular-editor";

import { FormIsValidDTO } from "src/app/parametrage/core/model/form-is-valid-dto";
import { FormulaireService } from "src/app/parametrage/core/service/formulaire.service";
import { ExecuterAllTask } from "src/app/mon-portefeuille/core/model/executer-all-task";
import { TaskService } from "src/app/mon-portefeuille/core/service/task.service";
import { RendezVousService } from "src/app/comite-credit/core/service/rendez-vous.service";
import { RendezVous } from "src/app/comite-credit/core/model/rendez-vous";
import { RendezVousSelectedDTO } from "src/app/comite-credit/core/model/rendez-vous-selected-dto";
import { AssocierRequestAuComite } from "src/app/comite-credit/core/model/associer-request-au-comite";

@Component({
  selector: "app-form-preparation-comite-superieur-credit",
  templateUrl: "./form-preparation-comite-superieur-credit.component.html",
  styleUrls: ["./form-preparation-comite-superieur-credit.component.scss"],
})
export class FormPreparationComiteSuperieurCreditComponent implements OnInit {
  requestId: string;
  taskId: string;

  checkFormDTO: FormIsValidDTO;
  command: ExecuterAllTask = new ExecuterAllTask();
  rendezVous: RendezVousSelectedDTO[];

  pressButton: Boolean = false;
  form: FormGroup;

  name = "Angular 6";
  htmlContent = "";

  checkIfComiteChoose = false;

  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: "8rem",
    minHeight: "5rem",
    placeholder: "Enter text here...",
    translate: "no",
    defaultParagraphSeparator: "p",
    defaultFontName: "Arial",
    toolbarHiddenButtons: [["bold"]],
    customClasses: [
      {
        name: "quote",
        class: "quote",
      },
      {
        name: "redText",
        class: "redText",
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ],
  };

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    public sanitizer: DomSanitizer,
    private _formulaireService: FormulaireService,
    private _taskService: TaskService,
    private _rendezVousService: RendezVousService
  ) {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      commentaire: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.requestId = params["requestId"];
      this.taskId = params["taskId"];
      this.checkIfFormIsValid(this.taskId);
      this.getCurrentRendezVousByType(this.requestId, "CCA");
    });
  }

  checkIfFormIsValid(taskId) {
    this._formulaireService.checkForm(taskId).subscribe(
      (data) => {
        this.checkFormDTO = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getCurrentRendezVousByType(requestId, typecomite) {
    this._rendezVousService.findSelected(requestId, typecomite).subscribe(
      (data) => {
        this.rendezVous = data;

        let check = false;
        this.rendezVous.forEach(function (value) {
          if (value.selected == true) {
            check = true;
          }
        });
        this.checkIfComiteChoose = check;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  changeAfterChecked(values: any, rendezVousId) {
    var input = new AssocierRequestAuComite();
    input.rendezVousId = rendezVousId;
    input.requestId = this.requestId;
    input.selected = values.currentTarget.checked;
    this.associer(input);
  }

  associer(associerProfileAEmployee: AssocierRequestAuComite) {
    this._rendezVousService.associer(associerProfileAEmployee).subscribe(
      (data) => {
        this.getCurrentRendezVousByType(this.requestId, "CCA");
      },
      (error) => {
        console.log(error);
      },
      () => {}
    );
  }

  executeTask(): void {
    this.command.taskId = this.taskId;
    this.command.requestId = this.requestId;
    this.command.messageText = this.htmlContent;

    this.pressButton = true;

    this.spinner.show();
    this._taskService
      .executerAllTask(this.command)
      .pipe(first())
      .subscribe(
        (data) => {
          this.spinner.hide();
          this._router.navigateByUrl("/mon-portefeuille/mes-dossiers");
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
        }
      );
  }

  cancel(): void {
    this._router.navigateByUrl("/mon-portefeuille/mes-dossiers");
  }
}
